import React, { useEffect, useRef } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Title,ChartDataLabels);

export function ExportPercentChart({ data, onImageReady, defaultColor = "#69AF45",graphHeight = 300, }) {
  const ref = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!ref.current) return;

      const canvas = ref.current.canvas || ref.current.ctx?.canvas;
      if (!canvas) return;

      const tempCanvas = document.createElement("canvas");
      const scale = 2;
      tempCanvas.width = canvas.width * scale;
      tempCanvas.height = canvas.height * scale;

      const ctx = tempCanvas.getContext("2d");
      ctx.scale(scale, scale);
      ctx.drawImage(canvas, 0, 0);

      const url = tempCanvas.toDataURL("image/png", 1.0);
      onImageReady && onImageReady(url);
    }, 400);

    return () => clearTimeout(timeout);
  }, [data]);

  const labels = data.map((d) => d.name);
  const values = data.map((d) => d.positive);
  const colors = data.map((d) => d.color || defaultColor);

  const getBandLabel = (value) => {
    if (!value) return "";
    if (value === 0) return "OPPORTUNITY";
    if (value > 0 && value < 60) return "OPPORTUNITY";
    if (value >= 60 && value < 90) return "DEVELOPING";
    if (value >= 90) return "STRENGTH";
    return "";
  };

  const chartData = {
    labels,
    datasets: [
      {
        label: "% Positive",
        data: values,
        backgroundColor: colors,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: false,
    animation: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels:{
        anchor: "center",
        align: "center",
        color: "#fff",
        font: {
          size: 13,
          weight: 400,
        },
        formatter: (value) => getBandLabel(value),
        clip: false,
        clamp: true,
      }
    },
    scales: {
      x: {
        type: "linear",
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: (value) => `${value}%`,
          font: { size: 12 },
        },
      },
      y: {
        type: "category",
        ticks: {
          color:"black",
          font: { size: 12 },
        },
      },
    },
  };

  return (
    <Bar
      ref={ref}
      data={chartData}
      options={options}
      width={800}
      height={graphHeight}
    />
  );
}
